import React, { useEffect, useRef, useState } from "react";
import { GrMoreVertical } from "react-icons/gr";
import Pagination from "../../components/pagination/pagination";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import errorToast from "../../components/toasts/errorToast";
import { availableLanguages } from "../../components/data/languageData";
import moment from "moment";
import {
    postEditingListAction,
    PublishDocAction,
} from "../../redux/actions/translationAction";
import successToast from "../../components/toasts/successToast";
import CustomButton from "../../components/button/button";
import ReactSelectFiled from "../../components/forms/reactSelect";
import { getLangName, truncateString } from "../../components/helper";
import { useAuth } from '../../context/AuthContext';

export const PostEditing = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [filteredData, setFilteredData] = useState([]);
    const [fileNameFilter, setfileNameFilter] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [pageFilter, setPageFilter] = useState("");
    const [sourceLangFilter, setSourceLangFilter] = useState("");
    const [targetLangFilter, setTargetLangFilter] = useState("");
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [translationStatusFilter, setTranslationStatusFilter] = useState("");

    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [paginationData, setPaginationData] = useState({});
    const [showOptions, setShowOptions] = useState(false);
    const [showClearIndex, setShowClearIndex] = useState(null);
    const dropdownRef = useRef(null);
    const { isAdmin, isTeamLead } = useAuth();
    const translationStatus = ["Completed", "Published", "Review"];

    const [selectAll, setSelectAll] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [sortColumn, setSortColumn] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");

    // Function to handle checkbox changes
    const handleCheckboxChange = (docId) => {
        if (selectedItems.includes(docId)) {
            setSelectedItems(selectedItems.filter((item) => item !== docId));
        } else {
            setSelectedItems([...selectedItems, docId]);
        }
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setSelectedItems([]);
        } else {
            setSelectedItems(filteredData.map((data) => data?.id));
        }
        setSelectAll(!selectAll);
    };

    useEffect(() => {
        setLoading(true);
        dispatch(
            postEditingListAction(
                {
                    page, page_size: rowsPerPage,
                    file_name: fileNameFilter,
                    status: statusFilter,
                    source_lang: sourceLangFilter,
                    target_lang: targetLangFilter,
                    no_of_pages: pageFilter,
                    from_date: startDate,
                    to_date: endDate,
                    translation_status: translationStatusFilter,
                },
                onSuccess,
                onError
            )
        );
    }, [page, rowsPerPage, fileNameFilter, statusFilter, sourceLangFilter, targetLangFilter, pageFilter, startDate, endDate, translationStatusFilter, dispatch]);

    const onSuccess = (data) => {
        setPaginationData(data?.data?.data?.pagination);
        setFilteredData(data?.data?.data?.jobs);
        setLoading(false);
    };
    const onError = (data) => {
        errorToast(data?.data?.message);
    };

    console.log("Loading ----------------", loading)

    const handleSort = (column) => {
        const newSortOrder =
            sortColumn === column && sortOrder === "asc" ? "desc" : "asc";
        const sortedData = [...filteredData].sort((a, b) => {
            if (a[column] < b[column]) return newSortOrder === "asc" ? -1 : 1;
            if (a[column] > b[column]) return newSortOrder === "asc" ? 1 : -1;
            return 0;
        });
        setSortColumn(column);
        setSortOrder(newSortOrder);
        setFilteredData(sortedData);
    };

    const handleMoreOptions = (item, index) => {
        setShowClearIndex(index);
        setShowOptions(!showOptions);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowOptions(false);
            setShowClearIndex(null);
        }
    };


    const onPublishSuccess = (data) => {
        dispatch(
            postEditingListAction(
                { page, page_size: rowsPerPage },
                onSuccess,
                onError
            )
        );
        setShowOptions(false);
        setShowClearIndex(null);
        successToast(data?.data?.message);
    };

    // Function to apply filters and fetch filtered data
    const handleApplyFilters = () => {
        setLoading(true);
        setFiltersApplied(true);
        dispatch(postEditingListAction({
            page,
            page_size: rowsPerPage,
            file_name: fileNameFilter,
            status: statusFilter,
            source_lang: sourceLangFilter,
            target_lang: targetLangFilter,
            no_of_pages: pageFilter,
            from_date: startDate,
            to_date: endDate,
            translation_status: translationStatusFilter,
        }, onSuccess, onError));
    };

    const handleClear = () => {
        console.log(filtersApplied);
        setLoading(false);
        setfileNameFilter('');
        setStatusFilter('');
        setSourceLangFilter('');
        setTargetLangFilter('');
        setStartDate('');
        setEndDate('')
        setPageFilter('');
        setFiltersApplied(false);
        setTranslationStatusFilter('');
    };
    const handleGetAllRecords = () => {
        setLoading(true);
        setfileNameFilter('');
        setStatusFilter('');
        setSourceLangFilter('');
        setTargetLangFilter('');
        setStartDate('');
        setEndDate('')
        setPageFilter('');
        setTranslationStatusFilter('');
        setFiltersApplied(true);
        dispatch(
            postEditingListAction(
                {
                    page, page_size: rowsPerPage,
                },
                onSuccess,
                onError
            )
        );
    };

    const handlePublishClick = (id) => {
        setLoading(true);
        dispatch(PublishDocAction({ ids: [id] }, onPublishSuccess, onError));
    };



    return (
        <div className="d-flex overflow-auto vh-100" onClick={handleClickOutside}>
            <div className="w-100">
                <div className="w-100 header align-items-center border-bottom  d-flex position-sticky top-0 bg-white py-2 justify-content-between z-1">
                    <h2 className="fs_20 fw_400 fn_Roboto text-start px-3 pt-1">Post Editing</h2>
                </div>

                <div className='d-flex flex-wrap gap-3 m-3'>
                    <div className='text-start'>
                        <span className="">File Name</span>
                        <div className='' style={{ width: '14rem' }}>
                            <input
                                type='text'
                                name='file_name'
                                className='input-field w-100'
                                placeholder="Enter name"
                                value={fileNameFilter}
                                onChange={(e) => setfileNameFilter(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className='text-start' style={{ width: '14rem' }}>
                        <ReactSelectFiled
                            onChange={(value) => setSourceLangFilter(value)}
                            options={availableLanguages}
                            label="Source Language"
                            value={sourceLangFilter}
                        />
                    </div>

                    <div className='text-start' style={{ width: '14rem' }}>
                        <ReactSelectFiled
                            onChange={(value) => setTargetLangFilter(value)}
                            options={availableLanguages}
                            label="Target Language"
                            value={targetLangFilter}
                        />
                    </div>
                    <div className='text-start' style={{ width: '14rem' }}>
                        <ReactSelectFiled
                            onChange={(value) => setTranslationStatusFilter(value)}
                            options={[
                                {
                                    label: "Completed",
                                    value: "Completed"
                                },
                                {
                                    label: "Published",
                                    value: "Published"
                                },
                                {
                                    label: "Review",
                                    value: "Review"
                                },
                                {
                                    label: "Sent Post Editing",
                                    value: "Sent Post Editing"
                                }
                            ]}
                            label="Translation Status"
                            value={translationStatusFilter}
                        />
                    </div>

                    <div className='text-start'>
                        <span className="">Pages</span>
                        <div className='' style={{ width: '14rem' }}>
                            <input
                                type='number'
                                name='pages'
                                className='input-field w-100'
                                placeholder="Enter a number"
                                value={pageFilter}
                                onChange={(e) => setPageFilter(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className='text-start'>
                        <span className="">From Date</span>
                        <div className='' style={{ width: '14rem' }}>
                            <input
                                type='date'
                                name='startDate'
                                className='input-field w-100'
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                max={new Date().toISOString().split('T')[0]}
                            />
                        </div>
                    </div>
                    <div className='text-start'>
                        <span className="">To Date</span>
                        <div className='' style={{ width: '14rem' }}>
                            <input
                                type='date'
                                name='endDate'
                                className='input-field w-100'
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                max={new Date().toISOString().split('T')[0]}
                            />
                        </div>
                    </div>

                </div>

                <div className="d-flex flex-wrap justify-content-start gap-3 mx-3 text-nowrap">
                    <CustomButton variant="primary" onClick={handleApplyFilters} disabled={!fileNameFilter && !statusFilter && !sourceLangFilter && !pageFilter && !targetLangFilter && !startDate && !endDate && !translationStatusFilter} >
                        Apply Filters
                    </CustomButton>
                    <CustomButton variant="primary" onClick={handleGetAllRecords}>
                        Show All
                    </CustomButton>
                    <CustomButton variant="secondary" onClick={handleClear}>
                        Clear Filters
                    </CustomButton>
                </div>

                {filtersApplied && (
                    <>
                        <div className="m-3">
                            <div className="table-responsive overflow-auto w-100" style={{ minHeight: '22rem' }}>
                                <table className="table table-bordered ">
                                    <thead className="table-light">
                                        <tr className="text-start text-nowrap">
                                            {(isAdmin || isTeamLead) && (
                                                <th width={"2%"} className="fw_400">
                                                    <input
                                                        type="checkbox"
                                                        checked={selectAll}
                                                        onChange={handleSelectAll}
                                                        aria-label="Select all documents"
                                                    />
                                                </th>
                                            )}
                                            <th
                                                width={"10%"}
                                                className="fw_400"
                                            >
                                                File Name
                                            </th>
                                            <th
                                                width={"10%"}
                                                className="fw_400"
                                            >
                                                Source Language
                                            </th>

                                            <th
                                                width={"10%"}
                                                className="fw_400"
                                            >
                                                Target Language
                                            </th>
                                            <th
                                                width={"10%"}
                                                className="fw_400"
                                            >
                                                Assigned By
                                            </th>
                                            {(isAdmin || isTeamLead) && (
                                                <th
                                                    width={"5%"}
                                                    className="fw_400"
                                                >
                                                    Editor
                                                </th>
                                            )}

                                            <th
                                                width={"10%"}
                                                className="fw_400"
                                            >
                                                Translation Status
                                            </th>
                                            {/* <th
                                                width={"6%"}
                                                className="fw_400"

                                            >
                                                Pages
                                            </th> */}
                                            {/* <th
                                                width={"5%"}
                                                className="fw_400"
                                            >
                                                Comments
                                            </th> */}
                                            <th
                                                width={"10%"}
                                                className="fw_400"
                                            >
                                                Created Date
                                            </th>

                                            <th width={"2%"} className="fw_400"></th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan="10">Loading...</td>
                                            </tr>
                                        ) : filteredData?.length > 0 ? (
                                            filteredData?.map((item, index) => (
                                                <tr key={index} className="text-start">
                                                    {(isAdmin || isTeamLead) && (
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedItems.includes(item.id)}
                                                                onChange={() => handleCheckboxChange(item.id)}
                                                                aria-label={`Select document ${item?.name}`}
                                                            />
                                                        </td>
                                                    )}
                                                    <td title={item?.file_name}>{truncateString(item?.file_name, 10)}</td>
                                                    <td>{getLangName(item?.source_lang)}</td>
                                                    <td>{getLangName(item?.target_lang)}</td>
                                                    <td title={item?.user?.email}>{truncateString(item?.user?.email, 15)}</td>
                                                    {(isAdmin || isTeamLead) && (
                                                        <td title={item?.editor?.email}>{truncateString(item?.editor?.email, 15)}</td>
                                                    )}
                                                    <td>{item?.translation_status}</td>
                                                    {/* <td>{item?.no_of_pages}</td> */}
                                                    {/* <td title={item?.post_edit_comments}>{truncateString(item?.post_edit_comments, 10) ?? "--"}</td> */}
                                                    <td>{moment(item?.createdAt).format('MM/DD/YY, hh:mm A')}</td>

                                                    <td>
                                                        <GrMoreVertical
                                                            className="cursor_pointer"
                                                            onClick={() => handleMoreOptions(item, index)}
                                                        />
                                                        {showOptions && showClearIndex === index && (
                                                            <div
                                                                className="position-relative"
                                                                ref={dropdownRef}
                                                            >
                                                                <div
                                                                    className="position-absolute"
                                                                    style={{ left: "-6rem" }}
                                                                >
                                                                    <div
                                                                        className="card"
                                                                        style={{ width: "6rem" }}
                                                                    >
                                                                        <div className="card-body p-2 fs_14">
                                                                            {(!translationStatus.includes(item?.translation_status)) && <label
                                                                                className="d-block cursor_pointer hover-effect text-nowrap"
                                                                                onClick={() => navigate(`/post-edit-okapi/${item?.id}`)}
                                                                            // onClick={() => item?.file_name.endsWith('.html') ? navigate(`/post-edit/${item?.id}`) : navigate(`/post-edit-okapi/${item?.id}`)}
                                                                            >
                                                                                Post-Edit
                                                                            </label>}

                                                                            {(isAdmin || isTeamLead) && (item?.translation_status !== "Published") &&
                                                                                <label className="d-block cursor_pointer hover-effect text-nowrap" onClick={() => navigate('/assign-user', { state: { jobs: [item?.id], is_reassign: false } })} >Re-Assign</label>
                                                                            }
                                                                            {(isAdmin || isTeamLead) && (item?.translation_status === "Completed") &&
                                                                                <label className="d-block cursor_pointer hover-effect text-nowrap"
                                                                                    onClick={() => {
                                                                                        handlePublishClick(item?.id);
                                                                                    }} >
                                                                                    Publish</label>
                                                                            }
                                                                            {item?.translation_status !== "Sent Post Editing" &&
                                                                                <label className="d-block cursor_pointer hover-effect text-nowrap"
                                                                                    onClick={() => { navigate(`/view-recent-translation/${item.id}`, { state: { is_review: ["Completed", "Published"].includes(item?.translation_status) ? false : true } }) }} >
                                                                                    {["Completed", "Published"].includes(item?.translation_status)
                                                                                        ? "View" : item?.translation_status === "Review" && "Review"}
                                                                                </label>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </td>

                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="10">No rows to display</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {paginationData?.total > 10 && (
                            <div className="px-5 pb-4 mt-2 d-flex justify-content-end">
                                <Pagination
                                    data={paginationData}
                                    nextFunc={() => setPage(page + 1)}
                                    prevFunc={() => setPage(page - 1)}
                                    setPageRowFunc={(value) => {
                                        setPage(1);
                                        setRowsPerPage(value);
                                    }}
                                />
                            </div>
                        )}
                    </>)}

            </div>
        </div >
    );
};

